var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hospital-terms-of-use__container"},[(!!_vm.hospitalTermsOfUseFileSource)?_c('iframe',{attrs:{"src":_vm.hospitalTermsOfUseFileSource,"type":"application/pdf","width":"100%","height":"100%","frameborder":"0"}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }